import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { cardCheckActions, CardQuery, CardOptionQuery, BinNumberQuery } from '@awp/nac/card-check/api';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { isNullOrEmpty } from '@awp/core/utils';
import { ApiInsuranceType } from '@awp/quote/models';
import { BinCheckComponent } from '../bin-check/bin-check.component';
var CardCheckComponent = /** @class */ (function () {
    function CardCheckComponent(cardQuery, cardOptionQuery, binQuery, store, changeDetectorRef, contentProvider) {
        this.cardQuery = cardQuery;
        this.cardOptionQuery = cardOptionQuery;
        this.binQuery = binQuery;
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.contentProvider = contentProvider;
        this.showBinNotFound = false;
        this.showAlternativeBinFound = false;
    }
    Object.defineProperty(CardCheckComponent.prototype, "context", {
        get: function () {
            return this._context;
        },
        set: function (value) {
            this._context = value;
            if (this.binCheckComponent != null) {
                this.binCheckComponent.clearBin();
            }
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    CardCheckComponent.prototype.ngOnInit = function () {
        var _this = this;
        // PreFetch benefits
        this.contentProvider.preFetchContent(['benefitTables'])
            .pipe(take(1), catchError(function (err) { return of(null); }))
            .subscribe();
        this.binQuery.values
            .pipe(untilDestroyed(this))
            .subscribe(function (p) {
            _this.showBinNotFound = (!isNullOrEmpty(p.binNumber) && p.binFound === false);
            _this.showAlternativeBinFound = (!isNullOrEmpty(p.binNumber) && p.alternativeBin === true);
        });
    };
    CardCheckComponent.prototype.ngOnDestroy = function () { };
    CardCheckComponent.prototype.onCardSelected = function (card) {
        this.selectedCard = card;
        this.contentData = {
            cardName: card.cardType.description,
            coverlevel: card.cardType.code
        };
        if (card.cardType.code == null) {
            var insuranceType = this.getInsuranceType();
            var errorCode = insuranceType === ApiInsuranceType.TravelInsurance ? 'PLAN_NOT_FOUND' : 'OTHER_INSURANCES_PLAN_NOT_FOUND';
            this.store.dispatch(new cardCheckActions.SelectCardTypeFailureAction(insuranceType));
        }
    };
    CardCheckComponent.prototype.onBinSearch = function (bin) {
        this.store.dispatch(new cardCheckActions.BinSearchAction(bin, this.getInsuranceType()));
    };
    CardCheckComponent.prototype.resetBin = function () {
        this.store.dispatch(new cardCheckActions.ResetBinSearch());
        this.showBinNotFound = false;
        this.selectedCard = null;
        this.showAlternativeBinFound = false;
    };
    CardCheckComponent.prototype.getInsuranceType = function () {
        switch (this._context.content.productName) {
            case "travelInsurance":
                return ApiInsuranceType.TravelInsurance;
            case "otherInsurance":
                return ApiInsuranceType.OtherInsurances;
            default:
                throw new Error('Expected travelInsurance or otherInsurance. Got "' + this._context.content.productName + '"');
        }
    };
    CardCheckComponent.prototype.onClearAlternativeBinError = function () {
        this.showAlternativeBinFound = false;
    };
    return CardCheckComponent;
}());
export { CardCheckComponent };
